// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N30A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledControl = styled.div({
	display: 'flex',
	padding: token('space.050', '4px'),
	boxShadow: `0 2px 0 ${token('color.border', N30A)}`,
	position: 'relative',
	zIndex: 1,
});
